module.exports = {"331124001":"西屏街道","331124002":"水南街道","331124003":"望松街道","331124101":"古市镇","331124102":"玉岩镇","331124103":"象溪镇","331124104":"大东坝镇","331124105":"新兴镇","331124201":"叶村乡","331124202":"斋坛乡","331124203":"三都乡","331124204":"竹源乡","331124205":"四都乡","331124206":"赤寿乡","331124208":"樟溪乡","331124211":"枫坪乡","331124212":"板桥畲族乡","331124213":"裕溪乡","331124214":"安民乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331124.json
// module id = 1133
// module chunks = 0